import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { HeartbeatApi } from '@kapi';
import { AuthenticationBloc } from '@kp/auth/authentication.bloc';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(
    private _authenticationBloc: AuthenticationBloc,
    private _heartbeatApi: HeartbeatApi,
    private _router: Router
  ) {}

  canActivate(/*route: ActivatedRouteSnapshot, state: RouterStateSnapshot*/): boolean | Observable<boolean | UrlTree> {
    if (this._authenticationBloc.isLoggedIn()) {
      // if says user is logged in locally, validate authentication before redirecting away
      return this._heartbeatApi.isValid$(true).pipe(
        map((isValid) => (isValid ? this._router.parseUrl('') : isValid)),
        catchError((err) => {
          console.warn(err);
          return of(false);
        })
      );
    }
    return true;
  }
}
